// Read at the time of the interaction so preference changes take effect
// without a reload. Unknown browser preferences use the quieter fallback.
export const getScrollBehavior = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'auto';
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
};
